
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"73","height":"25","viewBox":"0 0 80 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_381_371)"}},[_c('path',{attrs:{"d":"M29.185 5.288h21.63v38.866h-21.63V5.288z","fill":"#FF5F00"}}),_c('path',{attrs:{"d":"M30.558 24.721c0-7.897 3.708-14.901 9.408-19.433A24.57 24.57 0 0024.72 0C11.056 0 0 11.056 0 24.721c0 13.665 11.056 24.721 24.721 24.721a24.57 24.57 0 0015.245-5.287c-5.7-4.464-9.408-11.537-9.408-19.434z","fill":"#EB001B"}}),_c('path',{attrs:{"d":"M80 24.721c0 13.665-11.056 24.721-24.721 24.721a24.569 24.569 0 01-15.245-5.288c5.768-4.532 9.408-11.536 9.408-19.433S45.734 9.82 40.034 5.288A24.57 24.57 0 0155.28 0c13.665 0 24.72 11.125 24.72 24.721z","fill":"#F79E1B"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_381_371"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h80v49.442H0z"}})])])])
          )
        }
      }
    